import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

const styles = theme => {
  return {
    root: {
      display: 'block',
      width: '450px',
      height: '450px',
      fill: theme.palette.primary.main,
    },
  };
};

const PortalFeaturesIcon = ({ className, classes, ...rest }) => {
  const iconClasses = classNames(className, classes.root);
  return (
    <SvgIcon
      className={iconClasses}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 275 233"
      {...rest}
    >
      <path
        stroke="#3488c8"
        strokeWidth="10.6713"
        strokeMiterlimit="10"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24608f"
        d="M85.5 97.5l26 45.1h52l26-45.1-26-45h-52l-26 45zM163.6 52.3l26
          45.1h52l26-45.1-26-45h-52l-26 45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24608f"
        d="M58.2 185.5c2.1.3 3.6 2.1 3.6 4.2 0 2.3-2 4.2-4.4 4.2-2.4
          0-4.4-1.9-4.4-4.2 0-2.1 1.6-3.8
          3.6-4.2v-73.9c-1.1-.3-1.9-1.3-1.9-2.5 0-1.4 1.2-2.6 2.7-2.6
          1.5 0 2.7 1.2 2.7 2.6 0 1.2-.8 2.2-1.9 2.5v73.9zM137.3
          185.1c2.1.4 3.6 2.2 3.6 4.3 0 2.4-2 4.4-4.4 4.4-2.4
          0-4.4-2-4.4-4.4 0-2.2 1.6-4 3.6-4.3v-28.4c-1.1-.3-1.9-1.2-1.9-2.6
          0-1.3 1.2-2.7 2.7-2.7 1.5 0 2.7 1.3 2.7 2.7 0 1.3-.8 2.2-1.9
          2.6v28.4zM216.3 185.5c2.1.3 3.6 2.1 3.6 4.2 0 2.3-2 4.2-4.4 4.2-2.4
          0-4.4-1.9-4.4-4.2 0-2.1 1.6-3.8 3.6-4.2v-73.9c-1.1-.3-1.9-1.3-1.9-2.5
          0-1.4 1.2-2.6 2.7-2.6 1.5 0 2.7 1.2 2.7 2.6 0 1.2-.8 2.2-1.9 2.5v73.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24608f"
        stroke="#3488c8"
        strokeWidth="10.67"
        strokeMiterlimit="10"
        d="M7.3 52.3l26 45.1h51.9l26.1-45.1-26.1-45H33.3l-26 45z"
      />
      <text transform="translate(15.82 205.88)">
        <tspan
          x="0"
          y="0"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          Locus-to-Gene{' '}
        </tspan>
        <tspan
          x="2"
          y="12"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          (L2G) analysis
        </tspan>
        <tspan
          x="18"
          y="24"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          pipeline
        </tspan>
      </text>
      <text transform="translate(100.82 205.88)">
        <tspan
          x="0"
          y="0"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          Fine mapping/
        </tspan>
        <tspan
          x="6.2"
          y="12"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          credible set
        </tspan>
        <tspan
          x="15.2"
          y="24"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          analysis
        </tspan>
      </text>
      <text transform="translate(182.56 205.88)">
        <tspan
          x="3"
          y="0"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          UK Biobank
        </tspan>
        <tspan
          x="12"
          y="12"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          FinnGen
        </tspan>
        <tspan
          x="-4"
          y="24"
          fill="#5b5f5f"
          fontFamily="Inter"
          fontWeight="bold"
          fontSize="10px"
        >
          GWAS Catalog
        </tspan>
      </text>
      <path
        fill="#fff"
        d="M69.8 34.6c0-2.8-1.1-5.5-3.1-7.4-2-2-4.7-3.1-7.4-3.1-2.8 0-5.5
          1.1-7.4 3.1-2 2-3.1 4.7-3.1 7.4 0 2.8 1.1 5.5 3.1 7.4 2 2 4.7 3.1
          7.4 3.1 2.8 0 5.5-1.1 7.4-3.1 2-2 3.1-4.6 3.1-7.4zm-16
          6.8l.6-.6-1.2-1.2-.6.6c-1.1-1.3-1.8-3-1.9-4.7h.8v-1.8h-.8c.2-1.7.8-3.3
          1.9-4.7l.6.6 1.2-1.2-.6-.6c1.3-1.1 3-1.8 4.7-1.9v.8h1.8v-.8c1.7.2
          3.3.8 4.7 1.9l-.6.6 1.2 1.2.6-.6c1.1 1.3 1.8 3 1.9 4.7h-.8v1.8h.7c-.2
          1.7-.8 3.3-1.9 4.7l-.6-.6-1.2 1.2.6.6a8.66 8.66 0 0 1-11.1 0z"
      />
      <path
        fill="#fff"
        d="M82.1 46H69.8v4.4h-7v-2.2c4.4-1.1 8.1-4.4 9.6-8.7 1.6-4.3
          1-9.1-1.6-12.9-2.6-3.8-6.9-6-11.5-6s-8.9 2.2-11.5 6a14.1 14.1
          0 0 0-1.6 12.9c1.6 4.3 5.2 7.6 9.6 8.7v2.2h-7V46H36.5v4.4H33v1.8h3.5V67H33v1.8h3.5v4.4h12.3v-4.4h21v4.4h12.3v-4.4h3.5V67h-3.5V52.1h3.5v-1.8h-3.5V46zM41.8
          71.4h-3.5V47.7h3.5v23.7zM47 34.6a12.25 12.25 0 0 1 12.3-12.3 12.25
          12.25 0 0 1 12.3 12.3 12.25 12.25 0 0 1-12.3 12.3A12.25 12.25 0 0 1
          47 34.6zm10.6 14h3.5v1.8h-3.5v-1.8zM47
          71.4h-3.5V47.7H47v23.7zm1.8-4.4V52.1h21V67h-21zm26.34.4h-3.5V47.7h3.5v23.7zm5.3
          0h-3.5V47.7h3.5v23.7z"
      />
      <path
        fill="#fff"
        d="M59.3 31.1c-.6 0-1.2.2-1.8.5l-2-2-1.2 1.2 2 2a3.45 3.45 0 0 0 1.7
          5c1.3.5 2.8.2 3.8-.8s1.3-2.5.8-3.8c-.6-1.3-1.9-2.1-3.3-2.1zm0
          5.2c-.7 0-1.3-.4-1.6-1.1-.3-.7-.1-1.4.4-1.9s1.3-.7 1.9-.4a1.71 1.71
          0 0 1 .6 2.8c-.4.4-.8.6-1.3.6zM55.8 39h7v1.8h-7V39z"
      />
      <g>
        <path
          fill="#fff"
          d="M115.1 123.5h1.7c0-.6 0-1.2.1-1.7h18.8c.1.6.1 1.2.1
            1.7h1.7c0-2.3-.6-4.5-1.8-6.4-1.2-1.9-2.8-3.5-4.8-4.6l-8.1-4.4c-1-.5-1.8-1.2-2.6-1.9h3.4v-1.7h-4.9c-.7-1.1-1.3-2.2-1.6-3.5h5.6v-1.7h-6c-.1-1.2-.1-2.3.1-3.5h5.9V94h-5.4c.4-1.3
            1.1-2.4 1.9-3.5h4.4v-1.7H121c.5-.4
            1.1-.8 1.6-1.2l8.8-5.1c3.8-2.2 6.2-6.4 6.2-10.8v-.2h-1.7v.2c0
            .5 0 1-.1 1.5H117c-.1-.5-.1-1-.1-1.5v-.2h-1.7v.2c0 4.4 2.4 8.6 6.2
            10.8l3.3 2-2.9 1.7a13.1 13.1 0 0 0-5.9 7.2c-1.1 3-1 6.3.1 9.3 1.2
            3 3.3 5.5 6.1 7l2.4 1.3-2.9 1.6c-2 1.1-3.6 2.7-4.8 4.6-1.1 1.8-1.7
            4-1.7 6.3zm20.3-48.6c-.4 1.3-1 2.4-1.8
            3.5h-14.4c-.8-1-1.4-2.2-1.8-3.5h18zM122.2
            81c-.4-.3-.9-.6-1.3-.9h10.9c-.4.3-.8.6-1.3.9l-4.2
            2.4-4.1-2.4zm13.1 39h-17.9c.4-1.3 1.1-2.4 2-3.5h14c.8 1.1 1.5
            2.2 1.9 3.5zm-8.9-8.1l3.9 2.1c.4.2.9.5 1.3.8h-10.3c.4-.3.8-.6
            1.3-.8l3.8-2.1z"
        />
        <path
          fill="#fff"
          d="M139.4 86.2c-3 0-5.9 1.2-8 3.3a11.36 11.36 0 0 0 0 16 11.36
            11.36 0 0 0 16 0 11.36 11.36 0 0 0
            0-16c-2.2-2.1-5.1-3.3-8-3.3zm9.5 11.3c0 .6-.1 1.2-.2
            1.7h-8.5l1.4-1c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-1.4-1h8.5c.1.5.2
            1.1.2 1.7zm-19.1 0c0-.6.1-1.2.2-1.7h7.3l2.3 1.7-2.3
            1.7H130c-.1-.6-.2-1.1-.2-1.7zm9.6-9.6a9.59 9.59 0 0 1 8.9
            6.1h-17.7c.7-1.8 1.9-3.3 3.5-4.4 1.5-1.1 3.3-1.7 5.3-1.7zm0
            19.1a9.59 9.59 0 0 1-8.9-6.1h17.7c-.7 1.8-1.9 3.3-3.5 4.4a9.28
            9.28 0 0 1-5.3 1.7z"
        />
        <path
          fill="#fff"
          d="M156.2 106.1l1.1-1.1-1.2-1.2-1.1 1.1-2-1.9c1.7-4.2
            1.4-9-.9-13a14.77 14.77 0 0 0-27.4 9.3c.6 4.5 3.2 8.5 7.2 10.9
            3.9 2.3 8.7 2.7 13 .9l1.9 1.9-1.1 1.1 1.2 1.2 1.1-1.1 5.8
            5.8a5.83 5.83 0 0 0 8.2 0 5.83 5.83 0 0 0
            0-8.2l-5.8-5.7zm-29.8-8.6c0-3.4 1.4-6.8 3.8-9.2a13.01 13.01 0 0 1
            18.4 18.4 13.01 13.01 0 0 1-22.2-9.2zm20.1 12.8c2.4-1.3 4.4-3.3
            5.7-5.7l1.5 1.5-5.7 5.7-1.5-1.5zm11.4 9.7a4 4 0 0
            1-2.9-1.2l-5.8-5.8 5.7-5.7 5.8 5.8a4.03 4.03 0 0 1-2.8 6.9z"
        />
      </g>
      <g>
        <path
          fill="#fff"
          d="M202.5 73.9a21.5 21.5 0 0
            1-16.7-11.5c-2.2-4.2-2.9-8.8-2.1-13.5.7-4.4 2.9-8.5 6.1-11.6
            1.9-1.9 3.3-2.9 5.6-4 4.7-2.3 9.9-2.9 15-1.6 1.4.4 2.5.8 4
            1.5l1.3.6 1.1-.5c6.1-3.1 13.5-3 19.6.1 2 1 3.5 2.2 5.2 3.9 1.9
            1.9 3 3.4 4.1 5.8 1 2 1.6 3.8 1.9 6 .2 1.3.3 4.1.2 5.6-.7 6.8-4.5
            12.8-10.4 16.4-2.3 1.4-4.7 2.3-7.5
            2.7-1.3.2-4.2.3-5.7.2-2.6-.3-5.3-1.1-7.6-2.3l-1-.5-.9.5c-1.8 1-4
            1.7-6.2 2.1-1 .2-1.5.2-3.3.2-1.2 0-2.4 0-2.7-.1zm5-2.4c1.7-.2
            3.7-.8
            5.3-1.5.5-.2.5-.3.4-.4-.1-.1-.4-.4-.8-.7-5-4.1-7.8-10.6-7.6-17.2a21.23
            21.23 0 0 1
            8-15.9c.3-.2.6-.4.6-.5 0-.1-2-.9-3-1.2-2.2-.6-3.9-.8-6.1-.8-4.1.1-7.7
            1.4-11 3.9-.9.7-2.6 2.3-3.3 3.2-3.3 4.2-4.8 9.4-4 14.7.9 6.6 5.5
            12.5 11.6 15 3.1 1.5 6.6 1.9 9.9 1.4zm20.2.2c4.6-.3 8.6-2.1
            11.9-5.3 6.1-5.8 7.7-14.8
            4-22.3-2.9-6-8.7-10-15.4-10.7-1.2-.1-3.6-.1-4.8.1-1
            .2-2.5.5-3.4.8-.8.3-2.2.9-2.2.9s.2.2.4.3c1.4 1.1 3.3 3.1 4.5 4.8
            3.5 5.2 4.6 11.7 2.9 17.7-1.1 4.1-3.7 8.1-6.9
            10.8-.5.4-.8.7-.8.7.1.1 1.8.8 2.7 1.1 1.7.5 3.5.8 5.5.9.2.2.9.2
            1.6.2zm-11.3-3.8c.7-.6 2-1.7 2.2-2
            .1-.1.1-.2-.3-.2-.2-.1-2-.5-4-1.1-3.6-1-3.7-1-3.5-.8.5.7 1.8 2.2
            2.7 3 .7.6 2 1.6 2.1 1.6 0 0 .4-.3.8-.5zm5-5.6c.3-.5.5-.9.5-1
            0-.1-14-3.9-14-3.8-.1.1.7 2.2 1 2.8l.2.5 11.3 3
            .2-.3c.1-.2.5-.7.8-1.2zm1.7-3.8c.3-.8.6-2.3.6-2.5
            0-.1-.1-.2-.6-.3-.3-.1-4-1.1-8.2-2.2l-7.7-2c-.1 0-.1 3.2.1 3.5.1.1
            1.7.6 7.8 2.2 4.2 1.1 7.7 2.1 7.7 2.1
            0-.1.2-.4.3-.8zm.9-6.4c-.1-2-.1-2-.6-2.1-1-.3-14.8-4-15-4-.1
            0-.2.1-.4.8-.2.5-.3 1.2-.4 1.6l-.2.7 8.3 2.2 8.3 2.2c.1.1.1-.5
            0-1.4zm-.9-5.5c-.4-1.3-.9-2.4-1.1-2.5-.4-.2-11.1-3-11.2-2.9-.7
            1-1.6 2.6-1.6 2.6.1.1 14.1 3.8 14.1 3.7.1 0
            0-.4-.2-.9zm-2.9-5.5c-1-1.3-2.5-2.8-3.8-3.8l-.8-.6-.5.3c-.7.5-1.7
            1.3-2.2 1.8l-.4.4 3.9 1.1c2.2.6 3.9 1.1 4 1.1 0 0 0-.2-.2-.3z"
        />
      </g>
    </SvgIcon>
  );
};

export default withStyles(styles)(PortalFeaturesIcon);
